import { makeStyles } from '@material-ui/styles';
import { Values } from '../../../../values/Values';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: Values.cores.corPrimaria
  },
  textoInstrucao: {
    fontWeight: 'bolder',
    textAlign: 'justify'
  },
  gridBotaoSalvar: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 15
  }
}));

export {useStyles}

